import testsApi from '../../api/tests';
import Test from '../../classes/models/Test';

const state = () => ({
    currentTest: null,
    activeTests: [],
    completedTests: [],
    draftTests: [],
    areTestsLoaded: false,
    currentTestAnswers: []
});

// getters
const getters = {
    activeTests(state) {
        return state.activeTests;
    },
    completedTests(state) {
        return state.completedTests;
    },
    draftTests(state) {
        return state.draftTests;
    },
    testsCount(state) {
        return {
            activeTest: state.activeTests.length,
            completedTests: state.completedTests.length,
            draftTests: state.draftTests.length,
        }
    },
    getCurrentTest(state) {
        return state.currentTest;
    },
    currentTestAnswers(state) {
        return state.currentTestAnswers;
    }
};

// actions
const actions = {
    store({commit, state, dispatch}, data) {
        if (!data.url) {
            // [Nick] We use progress bar for URL scraping instead of common loader
            commit('setIsLoading', true, {root: true});
        }
        return testsApi.store(data).then(response => {
            commit('setCurrentTest', response.test);
            return Promise.resolve(response.test);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
    show({commit, state, dispatch}, testId) {
        commit('setIsLoading', true, {root: true});
        return testsApi.show(testId).then(data => {
            commit('setCurrentTest', data.test);
            return Promise.resolve(data.test);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
    delete({commit, state, dispatch}, {status, testId}) {
        commit('setIsLoading', true, {root: true});
        return testsApi.delete(testId).then(data => {
            commit('unsetTypeTest', {status, testId});
            return Promise.resolve(data.test);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
    index({commit, state, dispatch}, status) {
        commit('setIsLoading', true, {root: true});
        return testsApi.index(status).then(data => {
            commit('setTypeTest', {status, data});
            return Promise.resolve(data.test);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
    update({commit, state, dispatch}, test) {
        commit('setIsLoading', true, {root: true});
        return testsApi.update(test).then(response => {
            commit('setCurrentTest', response.test);
            return Promise.resolve(response.test);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
    payment({commit, state, dispatch}, {test, paymentIntentId, invoiceId}) {
        commit('setIsLoading', true, {root: true});
        return testsApi.payment(test, paymentIntentId, invoiceId).then(response => {
            commit('setCurrentTest', response.test);
            return Promise.resolve(response.test);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
    createIntent({commit, state, dispatch}, {test, coupon}) {
        commit('setIsLoading', true, {root: true});
        return testsApi.createIntent(test, coupon).then(response => {
            return Promise.resolve(response);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
    loadTestAnswers({commit, state, dispatch}, testId) {
        commit('setIsLoading', true, {root: true});
        return testsApi.answers(testId).then(response => {
            commit('setCurrentTestAnswers', response);
            return Promise.resolve(response);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
    toggleAnswerLike({commit, state, dispatch}, answerId) {
        commit('setIsLoading', true, {root: true});
        return testsApi.toggleAnswerLike(answerId).then(isLiked => {
            commit('setAnswerLike', {answerId, isLiked});
            return Promise.resolve(isLiked);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
    toggleAnswerHide({commit, state, dispatch}, answerId) {
        commit('setIsLoading', true, {root: true});
        return testsApi.toggleAnswerHide(answerId).then(isHidden => {
            commit('setAnswerHide', {answerId, isHidden});
            return Promise.resolve(isHidden);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
    uploadImage({commit, state, dispatch}, {test, payload}) {
        commit('setIsLoading', true, {root: true});
        return testsApi.uploadImage(test, payload).then(response => {
            return Promise.resolve(response);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
};

// mutations
const mutations = {
    setCurrentTest(state, test) {
        state.currentTest = new Test(test);
    },
    unsetTypeTest(state, data) {
        state[data.status + 'Tests'] = state[data.status + 'Tests'].filter(function(item) { return item['id'] !== data.testId })
    },
    setTypeTest(state, data) {
        state[data.status + 'Tests'] = data.data.test;
    },
    clearCurrentTest(state) {
        state.currentTest = null;
    },
    setCurrentTestAnswers(state, answers) {
        state.currentTestAnswers = answers;
    },
    setAnswerLike(state, {answerId, isLiked}) {
        _.each(state.currentTestAnswers, answer => {
            if (answer.id == answerId) {
                answer.is_liked = isLiked;
                return false;
            }
        });
    },
    setAnswerHide(state, {answerId, isHidden}) {
        _.each(state.currentTestAnswers, answer => {
            if (answer.id == answerId) {
                answer.is_hidden = isHidden;
                return false;
            }
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
